import React, { useRef, useLayoutEffect, useEffect, useState } from 'react';
import gsap from 'gsap';
import { DiVisualstudio } from "react-icons/di";
import "./EnterPage.css"
import { ScrollTrigger } from 'gsap/ScrollTrigger';


gsap.registerPlugin(ScrollTrigger);

const EnterPage = () => {

    const firstRef = useRef();
    const first1Ref = useRef();
    const first2Ref = useRef();
    const secondRef = useRef();
    const wrapperRef = useRef();

    useLayoutEffect(() => {
        const ctx = gsap.context((self) => {
            const sections = self.selector("section");
            const stopPanel = sections.findIndex((section) => section.dataset.pin);
            const stopPanel2 = sections.findIndex((section) => section.dataset.pin2);

            // Calculate the total width needed for the scroll
            const totalWidth = wrapperRef.current.offsetWidth * (sections.length - 1);

            const tl = gsap.timeline({
                defaults: {
                    ease: "none"
                },
                scrollTrigger: {
                    animate: "ease",
                    trigger: wrapperRef.current,
                    pin: true,
                    scrub: 1,  // Increase scrub value to slow down the scroll
                    snap: 0.2 / (sections.length - 0.4),
                    end: () => "+=" + totalWidth
                }
            })
            tl.to(sections, {
                xPercent: -(100 * stopPanel),
                duration: stopPanel,
            })
            tl.to(firstRef.current, {
                duration: 5,
                delay: 4,
                scale: 100,
                translateX: 1000

            })
            tl.to({ moveValue: 0 }, {
                duration: 5,
                moveValue: -210,
                onUpdate: function () {
                    const move = this.targets()[0].moveValue / 1; // Convert 0-100 range to 0-1
                    gsap.set(first1Ref.current, { translateX: move });
                }
            })
            tl.to({ moveValue: 0, opacityValue: 0 }, {
                duration: 7,
                opacityValue: 1,
                moveValue: 210,
                onUpdate: function () {
                    const move = this.targets()[0].moveValue; // Directly use moveValue
                    const opacity = this.targets()[0].opacityValue; // Directly use opacityValue
                    gsap.set(first2Ref.current, { x: -move, opacity: opacity }); // Use 'x' for translateX
                }
            });

            tl.to(sections, {
                xPercent: -(100 * stopPanel2),
                delay: 2,
                duration: stopPanel2 * 2
            })
            tl.to(secondRef.current, {
                duration: 8,
                delay: 5,
                scale: 2,
                rotateZ: 90,
            }).to(secondRef.current, {
                duration: 8,
                delay: 1,
                y: 1500,
                onUpdate: function () {
                    const move = gsap.getProperty(secondRef.current, "y") / 300; // Convert 0-300 range to 0-1
                    gsap.set(first2Ref.current, { translateY: move * 300 }); // Scale the move to match the original range
                }
            });


            tl.to(sections, {
                yPercent: (100 * (sections.length - 1)),
                duration: sections.length - stopPanel2 * 2
            });
        }, wrapperRef);

        return () => ctx.revert();
    }, []);

    const [color, setColor] = useState(getComputedStyle(document.documentElement).getPropertyValue('--color-bg').trim()); // Default background color
    const [spread, setSpread] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            // Determine the scroll threshold based on the device type
            const scrollThreshold = window.innerWidth <= 750 ? 2150 : 2800;

            // Change color and trigger spread effect when user scrolls
            if (window.scrollY > scrollThreshold) {
                setColor(getComputedStyle(document.documentElement).getPropertyValue('--color-bg').trim()); // Button color
                setSpread(true);
            } else {
                setColor(getComputedStyle(document.documentElement).getPropertyValue('--color-primary').trim()); // Default background color
                setSpread(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Cleanup event listener on component unmount
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);




    return (
        <div className="wrapperenter" ref={wrapperRef}>

            <section className={`container HEL ${spread ? 'spread' : ''}`} style={{ backgroundColor: color }} data-pin="true">
                <h2 ref={firstRef} style={{ fontSize: "10rem" }}><DiVisualstudio /></h2>
                <h2 className='welc-contentHL'>Welcome To My Portfolio</h2>
                <div className='welc-content' style={{ zIndex: "1" }}>
                    <h2 ref={first1Ref} className='greating' style={{ zIndex: "2" }} >Hi i'm Mohamed Metwally</h2>
                    <br />
                    <br />
                    <h2 ref={first2Ref} style={{ color: "#ffefe098", zIndex: "1", opacity: "0" }} >Web Designer <span>& Front ~ End Web Developer</span></h2>
                </div>

            </section>
            <section className="secondenter" data-pin2="true">
                <h2 ref={secondRef}> <span>Get To Know </span>
                    About Me
                </h2>
            </section>
        </div>
    )
}

export default EnterPage